var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDown105 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 105,
  height: 105,
  viewBox: "0 0 105 105",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.1464 32.1464C12.3417 31.9512 12.6583 31.9512 12.8536 32.1464L52.5 71.7929L92.1464 32.1464C92.3417 31.9512 92.6583 31.9512 92.8536 32.1464C93.0488 32.3417 93.0488 32.6583 92.8536 32.8536L52.8536 72.8536C52.6583 73.0488 52.3417 73.0488 52.1464 72.8536L12.1464 32.8536C11.9512 32.6583 11.9512 32.3417 12.1464 32.1464Z",
  fill: "currentColor"
})));
export default SvgArrowDown105;